<mat-toolbar color="primary">
  <img src="../assets/logo.png">
  <div class="title"  [routerLink]="['/']" style="cursor: pointer;">{{ title }}</div>
  <div class="toolbar-spacer"></div>

  <!-- Menu Icon -->
  <button mat-icon-button [matMenuTriggerFor]="mainMenu">
    <mat-icon>menu</mat-icon>
  </button>

  <!-- Menu Definition -->
  <mat-menu #mainMenu="matMenu">
    <button mat-menu-item [routerLink]="['/']">
      <mat-icon>home</mat-icon>
      <span>Home</span>
    </button>
    <button mat-menu-item [routerLink]="['/private/Tracking/Events/Producers-Consumers']">
      <mat-icon>flash_on</mat-icon>
      <span>Events details</span>
    </button>

    <button mat-menu-item>
      <mat-icon> traffic</mat-icon>
      <span>Systems health</span>
    </button>
  </mat-menu>
  @if (loginDisplay) {
    @if (userName) {
      <span style="padding-right: 10px;">Welcome, {{ userName }}</span>
    }
    <button mat-raised-button (click)="logout()">Logout</button>
  }
</mat-toolbar>
<div class="container">
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  @if (!isIframe) {

    <router-outlet></router-outlet>
  }
  @if (!loginDisplay) {
    <div class="login-page">
      <a href="#" (click)="loginRedirect()" class="login-btn">Login</a>
    </div>
  }
</div>


<app-footer></app-footer>